import React from 'react'
export default class RichEditor extends React.Component {
  render () {
    return "富文本编辑器"
  }
}
